import { createOptions } from "@/config/contentful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

type RichTextLinks = {
  entries?: { block?: Array<{ sys?: { id?: string } } | null> | null } | null;
};

export default function RichText({
  json,
  className,
  assets,
  links,
}: {
  json: any;
  className?: string;
  /** Full asset records for embedded assets (see lib/rich-text-assets). */
  assets?: any[];
  /** GraphQL `links` for the rich text field (embedded entries, e.g. Inline Images). */
  links?: RichTextLinks | null;
}) {
  const assetsMap = assets
    ? new Map(assets.map((a) => [a.sys?.id || a.id, a]))
    : undefined;

  const entryBlocks = links?.entries?.block?.filter(Boolean) ?? [];
  const entriesMap = entryBlocks.length
    ? new Map(entryBlocks.map((entry: any) => [entry.sys?.id, entry]))
    : undefined;

  const options = createOptions(assetsMap, entriesMap);

  return (
    <div className={`rich-text ${className}`}>
      {documentToReactComponents(json, options)}
    </div>
  );
}
